var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequestPause({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 13.6668C2.98467 13.6668 0 10.6822 0 7.00016C0 3.31816 2.98467 0.333496 6.66667 0.333496C10.3487 0.333496 13.3333 3.31816 13.3333 7.00016C13.3333 10.6822 10.3487 13.6668 6.66667 13.6668ZM4.66667 5.00016V9.00016H6V5.00016H4.66667ZM7.33333 5.00016V9.00016H8.66667V5.00016H7.33333Z",
    fill: "#FF4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestPause);
export default __webpack_public_path__ + "static/media/request-pause.d5a01b6454bdb53adfa671947b466f04.svg";
export { ForwardRef as ReactComponent };